import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/place.svg'


const _withScopeId = n => (_pushScopeId("data-v-652f41b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "book-info" }
const _hoisted_2 = { class: "content-wrapper" }
const _hoisted_3 = { class: "info-detail book-number-info" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-title" }, "예약번호", -1 /* HOISTED */))
const _hoisted_5 = { class: "info-content" }
const _hoisted_6 = { class: "info-detail line-info" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-title" }, "탑승노선", -1 /* HOISTED */))
const _hoisted_8 = { class: "info-content" }
const _hoisted_9 = { class: "line-route-name" }
const _hoisted_10 = { class: "info-detail departure-info" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-title" }, "승차", -1 /* HOISTED */))
const _hoisted_12 = { class: "bus-stop-name" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "지도에서 위치 보기"
}, null, -1 /* HOISTED */))
const _hoisted_14 = { class: "info-detail arrival-info" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-title" }, "하차", -1 /* HOISTED */))
const _hoisted_16 = { class: "bus-stop-name" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "지도에서 위치 보기"
}, null, -1 /* HOISTED */))
const _hoisted_18 = { class: "info-detail car-no" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-title" }, "차량정보", -1 /* HOISTED */))
const _hoisted_20 = { class: "info-content" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "info-detail book-date-info" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-title" }, "예약일시", -1 /* HOISTED */))
const _hoisted_24 = { class: "info-content" }
const _hoisted_25 = {
  key: 0,
  class: "info-detail book-date-info"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-title" }, "취소일시", -1 /* HOISTED */))
const _hoisted_27 = { class: "info-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", null, _toDisplayString($props.bookInfo.bookNum), 1 /* TEXT */),
          _createElementVNode("div", {
            class: _normalizeClass(["book-num-status", [$setup.bookStatusClassTable[$props.bookInfo.bookStatus]]])
          }, _toDisplayString($props.bookInfo.bookStatus), 3 /* TEXT, CLASS */)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createVNode($setup["LineTypeChip"], {
            lineTypeCode: $props.bookInfo.lineTypeCode,
            lineTypeName: $props.bookInfo.lineTypeName,
            isSmallSize: true
          }, null, 8 /* PROPS */, ["lineTypeCode", "lineTypeName"]),
          _createElementVNode("p", _hoisted_9, _toDisplayString($setup.useGetLineRouteName(
                $props.bookInfo.lineTypeCode,
                $props.bookInfo.routeName,
                $props.bookInfo.lineNum
              )) + " " + _toDisplayString($props.bookInfo.firstStopTime), 1 /* TEXT */)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", {
          class: "info-content",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onClickBusStopLocation', $props.bookInfo.getOnStopId)))
        }, [
          _createElementVNode("p", _hoisted_12, _toDisplayString($props.bookInfo.getOnStopName), 1 /* TEXT */),
          _createElementVNode("span", null, _toDisplayString(`(${$props.bookInfo.departureTime})`), 1 /* TEXT */),
          _hoisted_13
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("div", {
          class: "info-content",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('onClickBusStopLocation', $props.bookInfo.getOffStopId)))
        }, [
          _createElementVNode("p", _hoisted_16, _toDisplayString($props.bookInfo.getOffStopName), 1 /* TEXT */),
          _createElementVNode("span", null, _toDisplayString(`(${$props.bookInfo.arrivalTime})`), 1 /* TEXT */),
          _hoisted_17
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("span", null, _toDisplayString($props.bookInfo.carNo ?? "-"), 1 /* TEXT */),
          ($props.bookInfo.vendorName)
            ? (_openBlock(), _createElementBlock("span", _hoisted_21, "(" + _toDisplayString($props.bookInfo.vendorName) + ")", 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _hoisted_23,
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("p", null, _toDisplayString($props.bookInfo.bookDateTime), 1 /* TEXT */)
        ])
      ]),
      ($props.bookInfo.bookStatus === $setup.BookStatusName.CANCEL)
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            _hoisted_26,
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("p", null, _toDisplayString($props.bookInfo.bookCancelDateTime), 1 /* TEXT */)
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}